import { render } from "./PopupGallery.vue?vue&type=template&id=639f5c52&scoped=true"
import script from "./PopupGallery.vue?vue&type=script&lang=js"
export * from "./PopupGallery.vue?vue&type=script&lang=js"

import "@css/popup.css?vue&type=style&index=0&id=639f5c52&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-639f5c52"]])

export default __exports__